import { userLocale } from '@/utils/locale';

/**
 * Formats a number according to the specified locale and formatting options using Intl.NumberFormat
 * @param {Object} params - The parameters object
 * @param {number} params.value - The number to format
 * @param {string} [params.locale] - The locale to use for formatting (BCP 47 language tag)
 * @param {Intl.NumberFormatOptions} [params.options={}] - Additional formatting options for Intl.NumberFormat
 * @returns {string} The formatted number string
 */
export const formatNumber = ({ value, locale = userLocale, options = {} }) => {
  return new Intl.NumberFormat(locale, options).format(value);
};

/**
 * Gets the pagination summary for a given pagination object
 * @param {Object} pagination - The pagination object
 * @returns {Object} The pagination summary object
 * @property {number} start - The start of the pagination
 * @property {number} end - The end of the pagination
 * @property {number} total - The total number of items
 */
export const getPaginationSummary = (pagination) => {
  if (!pagination?.total) return { start: 0, end: 0, total: 0 };
  const { page, per_page, total } = pagination;
  const start = total === 0 ? 0 : (page - 1) * per_page + 1;
  const end = Math.min(page * per_page, total);
  return { start, end, total };
};
